import { Pipe, PipeTransform } from '@angular/core';
import { AccountIdService } from '../account/account-id.service';

function relativePath(path: string) {
  return path && path.startsWith('/') ? path.slice(1) : path;
}

@Pipe({ name: 'accountRoot' })
export class AccountRootPipe implements PipeTransform {
  transform(value: string): string {
    return `/accounts/${this.accountIdService.value}/${relativePath(value)}`;
  }

  constructor(private readonly accountIdService: AccountIdService) {}
}
